import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-modal',
  standalone: false,
  templateUrl: './delete-modal.html',
  styleUrl: './delete-modal.css'
})
export class DeleteModal {
  @Input() description: string = "Are you sure you want to delete this item?"
  @Output() event = new EventEmitter<Boolean>()

  constructor(private modal: NgbActiveModal) {
  }

  cancel() {
    this.modal.close(false)
  }

  confirm() {
    this.modal.close(true)
  }
}
